import { getMessageDisplayManager } from './message-display-manager.js';
import { getCurrentLayoutMode } from './layout-mode.js';

let displayManagerPromise = null;
let lastLayoutMode = null;

export async function getDisplayManager() {
    if (!displayManagerPromise) {
        displayManagerPromise = getMessageDisplayManager();
    }
    const displayManager = await displayManagerPromise;
    const layoutMode = getCurrentLayoutMode();
    if (displayManager?.setLayoutMode && lastLayoutMode !== layoutMode) {
        await displayManager.setLayoutMode(layoutMode);
        lastLayoutMode = layoutMode;
    }
    return displayManager;
}
